import { ReactNode } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { cn } from "../../utils/cn";

type CTAButtonProps = {
  href: string;
  children: ReactNode;
  variant?: "primary" | "secondary";
  className?: string;
};

function ButtonInner({ children }: { children: ReactNode }) {
  return (
    <>
      <span>{children}</span>
      <ArrowUpRight className="h-4 w-4" aria-hidden="true" />
    </>
  );
}

export function CTAButton({ href, children, variant = "primary", className }: CTAButtonProps) {
  const isInternalLink = href.startsWith("/");
  const baseClasses = cn(
    "inline-flex items-center gap-2 rounded-full px-6 py-2 text-sm font-medium transition",
    variant === "primary"
      ? "bg-emerald-400 text-slate-900 hover:bg-emerald-300"
      : "bg-white/10 text-slate-100 hover:bg-white/20",
    className
  );

  if (isInternalLink) {
    return (
      <Link to={href} className={baseClasses}>
        <ButtonInner>{children}</ButtonInner>
      </Link>
    );
  }

  return (
    <a href={href} className={baseClasses}>
      <ButtonInner>{children}</ButtonInner>
    </a>
  );
}
